import {AfterViewInit, Component, OnInit, ViewChild, ViewContainerRef, inject, DestroyRef} from '@angular/core';
import {SidenavService} from '../services/util/sidenav.service';
import {MatSidenav} from '@angular/material/sidenav';
import {ScrollService} from '../services/util/scroll.service';
import {NavigationEnd, Router} from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {AuthService} from '../services/auth/auth.service';
import {TourService} from '../services/util/tour.service';
import {SessionManagementService} from '../services/util/session-management.service';
import {FabricService} from '../services/fabric/fabric.service';
import {Permission} from '../models/principal/permission';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent  implements OnInit, AfterViewInit {
  @ViewChild('sidenav') sidenav: MatSidenav;
  @ViewChild('rightSidenav', {static: true}) private rightSidenav: MatSidenav;
  @ViewChild('container', {static: true, read: ViewContainerRef}) private viewContainerRef: ViewContainerRef;
  @ViewChild('scrollableContainer') private scrollableContainer;
  isEnterprise: boolean;
  verticalMenuItems: any;
  switchTenant: boolean;
  closed: boolean;
private destroyRef = inject(DestroyRef);
  constructor(public sidenavService: SidenavService, private scrollService: ScrollService,
              private router: Router, private authService: AuthService,
              private tourService: TourService, private sessionService: SessionManagementService,
              private fabricService: FabricService) {
    
  }

  ngOnInit(): void {
    this.sidenavService.setRightSidenav(this.rightSidenav);
    this.sidenavService.setViewContainerRef(this.viewContainerRef);
    this.addNavigationHandler();
    // this.startSessionMonitoring();
  }

  mouseEnter(): void {
    if (!this.sidenavService.isExpanded) {
      this.sidenavService.isShowing = true;
    }
  }

  mouseLeave(): void {
    if (!this.sidenavService.isExpanded) {
      this.sidenavService.isShowing = false;
    }
  }

  closeMenu(): void {
    this.closed = true;
  }

  ngAfterViewInit(): void {
    this.scrollService.setScrollableContainer(this.scrollableContainer.elementRef.nativeElement);
  }

  scroll($event: Event): void {
    this.scrollService.publishScrollEvent($event);
  }

  onSwitchClick(): void {
    this.switchTenant = true;
    this.router.navigate(['/',this.authService.principal.provider, 'tenant']);
    localStorage.setItem('switchTenant', JSON.stringify(this.switchTenant));
  }

  private startSessionMonitoring(): void {
    this.sessionService.expirationEvent
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(expired => {
        if (expired) {
          this.fabricService.getClient().isAnonymousProvider = true;
          this.authService.logout();
        }
      });
  }

  private addNavigationHandler(): void {
    this.router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((evt) => {
        if (!(evt instanceof NavigationEnd)) {
          return;
        }
        this.sidenavService.closeRightSidenav();
        this.scrollService.scrollTo(0);
        this.tourService.hideTour();
      });
  }
}
